import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const ImportProgress = ({ progress, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="mb-3">
      <ProgressBar 
        now={progress} 
        label={`${progress}%`}
        striped 
        animated={progress < 100}
      />
    </div>
  );
};

export default ImportProgress;